// we have a duplicate here "apps/frontend/process-data/src/createPublicJsonData/helpers/consts.ts"
const JobDetailsCompanyDictonary = {
  Betriebsrat: 'enercity AG',
  'Bereich Dezentrale Lösungen&Engineering': 'enercity AG',
  'Abt. Kundenlösungen Energieeffizienz': 'enercity AG',
  'Abt. Kundenlösungen Strom': 'enercity AG',
  'Abt. Kundenlösungen Wärme': 'enercity AG',
  'FG Betrieb Kundenanlagen': 'enercity AG',
  'Bereich Dienstleistungen': 'enercity AG',
  'Abt. Technik': 'enercity AG',
  'Abt. Smart IoT/Metering': 'enercity AG',
  'ATZ/LEAZK Bereich eAG Altersteilzeit/LEAZK': 'enercity AG',
  'ATZ/LEAZK Bereich eNG Altersteilzeit/LEAZK': 'enercity Netz GmbH',
  'Abt. eCG Biogas, kfm. Service, Mobilität': 'enercity Contracting GmbH',
  'FG Energiewirtschaft': 'enercity Contracting GmbH',
  'FG Kaufmännischer Service': 'enercity Contracting GmbH',
  'Abt. eCG Projektmanagement & Betriebsst.': 'enercity Contracting GmbH',
  'FG Betriebssteuerung': 'enercity Contracting GmbH',
  'FG Projektmanagement': 'enercity Contracting GmbH',
  'Abt. eCG Vertrieb & IT': 'enercity Contracting GmbH',
  'FG eCG Vertrieb': 'enercity Contracting GmbH',
  'Bereich Energiewirtschaft & Handel': 'enercity AG',
  'Abt. Back Office': 'enercity AG',
  'Bereich Finanzen & Einkauf': 'enercity AG',
  'Abt. Einkauf': 'enercity AG',
  'Abt. Finanzierung': 'enercity AG',
  'Abt. Steuern': 'enercity AG',
  'eNG Geschäftsführung': 'enercity Netz GmbH',
  'Abt. Berufsausbildung': 'enercity Netz GmbH',
  'FG Berufsausbildung kfm.': 'enercity Netz GmbH',
  'Bereich People & Organization': 'enercity AG',
  'Geschäftsstab Konzernkommunikation': 'enercity AG',
  'Stab Konzernrevision': 'enercity AG',
  'Bereich Netzbetrieb': 'enercity Netz GmbH',
  'Abt. Entstörung': 'enercity Netz GmbH',
  'FG Entstörung G/W': 'enercity Netz GmbH',
  'FG Entstörung S & zentrale Störungsannah': 'enercity Netz GmbH',
  'Abt. Netzführung': 'enercity Netz GmbH',
  'Abt. Netz- & Geodaten': 'enercity Netz GmbH',
  'FG Vermessung': 'enercity Netz GmbH',
  'FG Dokumentation': 'enercity Netz GmbH',
  'Abt. Sekundärtechnik': 'enercity Netz GmbH',
  'Bereich Netzservice': 'enercity Netz GmbH',
  'Abt. Arbeitssteuerung': 'enercity Netz GmbH',
  'FG Zentraler Service': 'enercity Netz GmbH',
  'FG Arbeitssteuerung Strom': 'enercity Netz GmbH',
  'FG Arbeitssteuerung G/W': 'enercity Netz GmbH',
  'Abt. Leitungsservice Strom/Gas/Wasser': 'enercity Netz GmbH',
  'FG Instandsetzung Leitungen G/W': 'enercity Netz GmbH',
  'FG Instandhaltung Leitungen S': 'enercity Netz GmbH',
  'FG Stellmaßnahmen G/W': 'enercity Netz GmbH',
  'Geschäftsstab Recht & Compliance': 'enercity AG',
  'KC Inkassoservice': 'enercity AG',
  'KC Recht': 'enercity AG',
  Schwerbehindertenvertretung: 'enercity AG',
  'Bereich Fernwärme & Wasser': 'enercity AG',
  'FG FW Arbeitnehmerüberlassung': 'enercity AG',
  'Bereich Unternehmensentwicklung': 'enercity AG',
  'Abt. Controlling': 'enercity AG',
  'FG Unternehmens- & Konzerncontrolling': 'enercity AG',
  'FG Controlling Märkte': 'enercity AG',
  'FG Geschäftsanalytik': 'enercity AG',
  'Abt. M&A & Beteiligungsmanagement': 'enercity AG',
  'Abt. Strategie & Innovation': 'enercity AG',
  'Bereich Vertrieb & Marketing': 'enercity AG',
  'Abt. Geschäftskunden': 'enercity AG',
  'FG Kundengruppe A': 'enercity AG',
  'FG Kundengruppe B': 'enercity AG',
  'FG Kundenservice': 'enercity AG',
  'FG Kundensupport': 'enercity AG',
  'Stab Vorstandsoffice': 'enercity AG',
  enercity: 'E91401 Vorstände',
  'VS 1 Bereichsleiter für Vorstand 1': 'enercity AG',
  'VS 2 Bereichsleiter für Vorstand 2': 'enercity AG',
  'VS 3 Bereichsleiter für Vorstand 3': 'enercity AG',
  'eNG 1 Geschäftsführung eNG 1': 'enercity Netz GmbH',
  'eNG 2 Geschäftsführung eNG 2': 'enercity Netz GmbH',
  Geschäftsstäbe: 'enercity AG',
  Stabsleiter: 'enercity AG',
  'GF1 Bereichsleiter für GF1': 'enercity Netz GmbH',
  'GF2 Bereichsleiter für GF2': 'enercity Netz GmbH',
  'Vorsitz BR Vorsitzender': 'enercity AG',
  'eCG1 Geschäftsführung eCG1': 'enercity Contracting GmbH',
  'eCG2 Geschäftsführung eCG2': 'enercity Contracting GmbH',
  'Abt. Marketing': 'enercity AG',
  'Abt. Privat- und Gewerbekunden': 'enercity AG',
  'Abt. Netznahe Dienstleistungen': 'enercity Netz GmbH',
  'FG Risk Management und Risk Controlling': 'enercity AG',
  'Abt. Smart Living': 'enercity AG',
  'Abt. Rechnungswesen Nebenbücher': 'enercity AG',
  'Abt. Rechnungswesen Hauptbücher & Einzelabschlüsse': 'enercity AG',
  'Abt. Rechnungswesen Konzernabschlüsse & Grundsatzfragen': 'enercity AG',
  'FG Commodity Vertrieb Privatkunden': 'enercity AG',
  'FG Commodity Vertrieb Gewerbekunden': 'enercity AG',
  'FG Lösungsvertrieb Privat- und Gewerbekunden': 'enercity AG',
  'Abt. Regulierungsmanagement': 'enercity AG',
  'FG Thermische Erzeugung & Fernwärme': 'enercity AG',
  'Abt. Strategisches Assetmanagement': 'enercity AG',
  'FG Netze und Speicher': 'enercity AG',
  'Abt. Kommunales Partnermanagement & Konzessionen': '',
  'Abt. Markets': 'enercity AG',
  'FG Modelle & Prognosen': 'enercity AG',
  'FG Pricing': 'enercity AG',
  'Abt. Origination': 'enercity AG',
  'Abt. Data Science & IT': 'enercity AG',
  'FG Short Term Markets': 'enercity AG',
  'FG Long Term Markets': 'enercity AG',
  'Bereich Kundenmanagement': 'enercity AG',
  'FG Qualitätssicherung & Steuerung': 'enercity AG',
  'FG Kundenprozess- & Qualitätsmanagement': 'enercity AG',
  'FG Marktkommunikationsmanagement': 'enercity AG',
  'Abt. Kundenservice': 'enercity AG',
  'Service & Winback': 'enercity AG',
  'Abt. Prozess- und Leistungsmanagement': 'enercity AG',
  'FG Kundencenter GREenercity': 'enercity AG',
  'FG Energie- und Finanzprozessmanagement': 'enercity AG',
  'Abt. Produktmanagement': 'enercity AG',
  'Abt. Operatives Management': 'enercity AG',
  'Abt. Engineering': 'enercity AG',
  'Abt. Projektvertrieb': 'enercity AG',
  'Abt. Geschäftsfeldentwicklung': 'enercity AG',
  'Abt. Instandhaltung': 'enercity AG',
  'Abt. Betrieb': 'enercity AG',
  'Abt. Development': 'enercity AG',
  'Abt. Digital Solutions': 'enercity AG',
  'Abt. Lifecycle': 'enercity AG',
  'Abt. Business Consulting': 'enercity AG',
  'Geschäftsstäbe 2': 'E91401 Vorstände',
  'Geschäftsstäbe 3': 'E91401 Vorstände',
  '2 Stabsleitung 2': 'E91401 Vorstände',
  '3 Stabsleitung 3': 'E91401 Vorstände',
  'Bereich Business Service': 'enercity Netz GmbH',
  'Bereich Meter2Cash': 'enercity Netz GmbH',
  'FG Center of Process Excellence': 'enercity Netz GmbH',
  'FG Betriebsrestaurants': 'enercity Netz GmbH',
  'FG Logistik': 'enercity Netz GmbH',
  'FG Mobilitäts- & Postservice': 'enercity Netz GmbH',
  'Abt. Abrechnungsleistung': 'enercity Netz GmbH',
  'FG Zahlungsmanagement': 'enercity Netz GmbH',
  'FG Datenmanagement': 'enercity Netz GmbH',
  'Bereich Engineering': 'enercity Netz GmbH',
  'Abt. Application Service': 'enercity Netz GmbH',
  'Abt. Kaufmännischer Service': 'enercity Netz GmbH',
  'Abt. Logistik & Mobilität': 'enercity Netz GmbH',
  'Abt. Immobilien': 'enercity Netz GmbH',
  'FG Immobilienbetrieb Glocksee': 'enercity Netz GmbH',
  'FG Immobilienbetrieb Ricklingen': 'enercity Netz GmbH',
  'FG Flächenmanagement': 'enercity Netz GmbH',
  'FG Abrechnung': 'enercity Netz GmbH',
  'FG Vertrags- & Kontaktmanagement': 'enercity Netz GmbH',
  'FG Anlagen': 'enercity Netz GmbH',
  'Abt. Datenübertragungsnetze': 'enercity Netz GmbH',
  'FG Projekte Datenübertragungsnetze': 'enercity Netz GmbH',
  'FG Betrieb Datenübertragungsnetze': 'enercity Netz GmbH',
  'Abt. Leitungsprojekte': 'enercity Netz GmbH',
  'FG Erschließung & Netzanschlüsse': 'enercity Netz GmbH',
  'FG Leitungsprojekte G/W': 'enercity Netz GmbH',
  'Abt. Netzmanagement': 'enercity Netz GmbH',
  'Abt. Anlagen- und Hochbauprojekte': 'enercity Netz GmbH',
  'FG Hochbau & Umspannwerke': 'enercity Netz GmbH',
  'FG Entwicklung Datenübertragungsnetze': 'enercity Netz GmbH',
  'FG Leitungsprojekte Strom': 'enercity Netz GmbH',
  'FG Leitungsprojekte FW': 'enercity Netz GmbH',
  'FG Customer-Care': 'enercity Netz GmbH',
  'Bereich Digitalisierung und IT': 'enercity Netz GmbH',
  'Abt. Data Management': 'enercity Netz GmbH',
  'Abt. Process Management': 'enercity Netz GmbH',
  'FG Service Management': 'enercity Netz GmbH',
  'Abt. Platform Services': 'enercity Netz GmbH',
  'FG IT-Office': 'enercity Netz GmbH',
  'FG Transition Hub': 'enercity Netz GmbH',
  'Abt. Workplace Solutions': 'enercity Netz GmbH',
  'FG Kommunikationssysteme': 'enercity Netz GmbH',
  'Abt. Information und Cyber Security': 'enercity Netz GmbH',
  'Geschäftsstab Digitalisierungs- und IT-Strategie': 'enercity AG',
  'FG Enterprise Architecture Management': 'enercity AG',
  'Abt. Digital Customer Experience': 'enercity AG',
  'FG Kundenlösungen Wärme B2C': 'enercity AG',
  'Stabs-Abteilung Health, Safety, Environment': 'enercity AG',
  'Stabs-Abteilung Safety & Environment': 'enercity AG',
  'Stabs-Abteilung Health': 'enercity AG',
  'FG Kommunale Wärmeplanung und Quartierskonzepte': 'enercity AG',
  'Abt. Auftrags-und Messstellenmanagement': 'enercity Netz GmbH',
  'Abt. Marktprozesse & EDM': 'enercity Netz GmbH',
  'Abt. Messwert- und Abrechnungsmanagement': 'enercity Netz GmbH',
  'Abt. Steuerung & Ressourcenmanagement': 'enercity Netz GmbH',
  'FG Prozesse und Applikationen': 'enercity AG',
  'Abt. AI & Digital Innovation': 'enercity Netz GmbH',
  'Chief Sales Officer': 'enercity AG',
  'GF Ökoloco': 'enercity AG',
  'FG Instandhaltung Leitungen Fernwärme': 'enercity Netz GmbH',
  'Abt. Instandhaltung Anlagen A': 'enercity Netz GmbH',
  'Abt. Instandhaltung Anlagen B': 'enercity Netz GmbH',
  'FG Zentrale Werkstätten': 'enercity Netz GmbH',
  'FG Instandhaltung Anlagen Strom': 'enercity Netz GmbH',
  'FG Instandhaltung Fernwärmestationen': 'enercity Netz GmbH',
  'FG Arbeitssteuerung Fernwärme': 'enercity Netz GmbH',
  'FG Instandhaltung Anlagen G/W': 'enercity Netz GmbH',
  'FG Wasserlabor': 'enercity Netz GmbH',
  'FG Instandhaltung Messen / Sperren': 'enercity Netz GmbH',
  'FG Wasser Betrieb': 'enercity AG',
  'FG Wasser Instandhaltung': 'enercity AG',
  'FG Umweltdienstleistungen & Forst': 'enercity AG',
  'FG Steuerung & Wasserwirtschaft': 'enercity AG',
  'Abt. proKlima': 'enercity AG',
  'FG AI Products & Engineering': 'enercity Netz GmbH',
  'FG Data Science & Analytics': 'enercity Netz GmbH',
  'FG Modern Work': 'enercity Netz GmbH',
  'FG Dienstleistungen Energieeffizienz': 'enercity Netz GmbH',
  'FG Operative Dienstleistungen': 'enercity Netz GmbH',
  'FG Berufsausbildung kaufmännisch': 'enercity Netz GmbH',
  'FG Berufsausbildung Elektro': 'enercity Netz GmbH',
  'FG Berufsausbildung Metall': 'enercity Netz GmbH',
  'FG Process Automation': 'enercity Netz GmbH',
  'Bereich Marktbereich': 'enercity AG',
  'Bereich Digitale Fähigkeiten & Prozesse': 'enercity AG',
  'Bereich E-Mobilität': 'enercity AG',
  'Abt. B2C Commodity Kundenservice': 'enercity AG',
  'Abt. B2B Projektgeschäft': 'enercity AG',
  'Abt. Konzernmarketing': 'enercity AG',
  'Abt. Geschäftsfeldentwicklung mobility': 'enercity AG',
  'Abt. Vertrieb enercity mobility': 'enercity AG',
  'Abt. Produktentwicklung': 'enercity AG',
  'Abt. Sales & Service Fähigkeiten': 'enercity AG',
  'Abt. B2C Commodity': 'enercity AG',
  'Abt. Standardisiertes Lösungsgeschäft': 'enercity AG',
  'Abt. Fulfillment Wärme': 'enercity AG',
  'Abt. B2B Commodity': 'enercity AG',
  'Abt. Vertriebssteuerung': 'enercity AG',
  'Abt. Technik enercity mobility': 'enercity AG',
  'Abt. Prozesse': 'enercity AG',
  'Abt. Energie-Innovation': 'enercity AG',
  'FG B2C Digital Growth': 'enercity AG',
  'FG B2C Multi-Channel-Vertrieb': 'enercity AG',
  'FG B2C Bestandskundenvertrieb': 'enercity AG',
  'FG B2C Service & Winback': 'enercity AG',
  'FG B2C QS & Steuerung': 'enercity AG',
  'FG Produktmanagement Lösungen': 'enercity AG',
  'FG Fachpartnerbetreuung': 'enercity AG',
  'FG B2B Vertrieb HDL & Öff. AG': 'enercity AG',
  'FG B2B Vertrieb Marktmittler & WoWi': 'enercity AG',
  'FG B2B KS Individualkunden': 'enercity AG',
  'FG B2B PM & Reporting': 'enercity AG',
  'FG B2C Produktmanagement & Kooperationen': 'enercity AG',
  'FG B2C Kundencenter': 'enercity AG',
  'FG Vertrieb Lösungen': 'enercity AG',
  'FG B2B Vertrieb Industrie & EVU': 'enercity AG',
  'FG B2B KS WoWi & Belieferungsmanagement': 'enercity AG',
  'FG Projektvertrieb Industrie': 'enercity AG',
  'FG Energie- & Finanzprozessmanagement': 'enercity AG',
  'FG Marktkommunikation': 'enercity AG',
  'FG Projektvertrieb Multisite': 'enercity AG',
  'FG Projektvertrieb Immobilienwirtschaft': 'enercity AG',
  'FG Kundenprozess & Qualitätsmanagement': 'enercity AG',
  'FG Identitäts- & Datenplattformen': 'enercity AG',
  'FG Sales Fähigkeiten': 'enercity AG',
  'FG Service Fähigkeiten': 'enercity AG',
};

const STANDALONE_COMPANY_NAMES = [
  'enercity Netz GmbH',
  'enercity Contracting GmbH',
];

const getJobDetailsCompanyHelpMessage = (
  companyDescriptor: string
): string | undefined => {
  const companyName = (JobDetailsCompanyDictonary as any)[companyDescriptor];

  if (companyName === 'enercity AG') {
    return;
  }

  if (!companyName || STANDALONE_COMPANY_NAMES.includes(companyName)) {
    return companyName;
  }

  return `enercity AG für die ${companyName}`;
};

export default getJobDetailsCompanyHelpMessage;
